import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './../css/filtermarketpricedb.scss';
import './../css/marketpricedb.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTable,
  faList,
  faEye,
  faAngleRight,
  faAngleDown,
  faExclamationCircle,
  faArrowLeft,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import { useHistory, useLocation } from 'react-router';
import FilterMarketpriceDb from './FilterMarketpriceDb';
import LoginModal from '../components/LoginModal';
import $ from 'jquery';
import Sidebar from '../components/Sidebar';
import BottomNav from '../components/BottomNav';
import TopNav from '../components/TopNav';
import Axios from 'axios';
import { API_MARKETPRICE_DB } from '../api/api';
import DetailKendaraan from '../components/DetailKendaraan';
import DataTable from 'react-data-table-component';
import ClipLoader from 'react-spinners/ClipLoader';
import Line from './../components/Line';
import { getMarketpriceDb } from '../redux/action/marketpriceAction';
import PaginationListView from '../components/PaginationListView';
import { marketpriceFilterFailed, marketpriceFilterSuccess, visitMarketDB } from '../services/amplitude';
import { moneyParser } from '../constant/currency';
import useCheckAuth from '../hooks/useCheckAuth';
import { HEADER_AUTH } from '../utils/API';
import { Button, Typography } from '@mui/material';


const MarketPricedb = () => {
  const dispatch = useDispatch();
  const [searching, setSearching] = useState(false);
  const [type, setType] = useState('table');
  const [detail, setDetail] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const [sortBy, setSortBy] = useState('');
  const [sortMethod, setSortMethod] = useState('');

  const [filterOpen, setFilterOpen] = useState(false);

  const [keyword, setKeyword] = useState(null);

  const marketprice = useSelector((state) => state.marketpriceReducer);
  const data = marketprice.data;

  const { success, error, error_code, message } = useSelector((state) => state.marketpriceReducer);
  const selectedValue = useSelector((state) => state.marketpriceReducer);

  const history = useHistory();
  const location = useLocation();
  const pageChannel = location.state && location.state.pageChannel;

  useEffect(() => {
    dispatch({
      type: 'NULLIFY',
    });
    visitMarketDB(pageChannel);
  }, []);

  useEffect(() => {
    if (success) {
      function isData(value) {
        if (value && value.length > 0) {
          return 'Ada';
        } else {
          return 'Tidak Ada';
        }
      }
      marketpriceFilterSuccess({
        item_brand: selectedValue && selectedValue.brand,
        item_series: selectedValue && selectedValue.series,
        item_type: selectedValue && selectedValue.type,
        item_cylinder: selectedValue && selectedValue.cylinder,
        auction_period: selectedValue && selectedValue.period,
        item_model: selectedValue && selectedValue.model,
        item_grade: selectedValue && selectedValue.grade,
        item_transmission: selectedValue && selectedValue.transmission,
        item_year_start: selectedValue && selectedValue.startYear,
        item_year_end: selectedValue && selectedValue.endYear,
        item_odometer_start: selectedValue && selectedValue.minKm,
        item_odometer_end: selectedValue && selectedValue.maxKm,
        item_color: selectedValue && selectedValue.color,
        item_owner: selectedValue && selectedValue.Kepemilikan,
        item_city: selectedValue && selectedValue.city,
        item_id: selectedValue && selectedValue.nopolisi,
        item_stnk: selectedValue && selectedValue.stnk,
        item_bpkb: selectedValue && selectedValue.bpkb,
        data_result: selectedValue && isData(selectedValue.data),
      });
    } else if (error) {
      marketpriceFilterFailed({
        status_message: message,
        status_code: error_code,
      });
    }
  }, [success]);

  useEffect(() => {
    if (keyword !== null) {
      let timer = setTimeout(() => {
        dispatch(
          getMarketpriceDb({
            ...marketprice,
            page: page,
            perPage: perPage,
            data: null,
            sortBy: sortBy,
            sortMethod: sortMethod,
            keyword: keyword,
          })
        );
        return () => clearTimeout(timer);
      }, 1000);
    }
  }, [keyword]);

  const onSearch = (payload) => {
    dispatch(getMarketpriceDb(payload.data));
    setSearching(false);
    setFilterOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePageChange = (page) => {
    setPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(
      getMarketpriceDb({
        ...marketprice,
        page: page,
        perPage: perPage,
        data: null,
        sortBy: sortBy,
        sortMethod: sortMethod,
        keyword: keyword,
      })
    );
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    dispatch(
      getMarketpriceDb({
        ...marketprice,
        page: page,
        perPage: newPerPage,
        data: null,
        sortBy: sortBy,
        sortMethod: sortMethod,
        keyword: keyword,
      })
    );
  };

  const handleSort = async (column, sortDirection) => {
    setSortBy(column.sortField);
    setSortMethod(sortDirection);
    dispatch(
      getMarketpriceDb({
        ...marketprice,
        data: null,
        page: page,
        perPage: perPage,
        sortBy: column.sortField,
        sortMethod: sortDirection,
        keyword: keyword,
      })
    );
  };

  const columns = [
    {
      name: 'Kendaraan',
      selector: (row) => row.title,
    },
    {
      name: 'Tahun',
      selector: (row) => row.year,
      sortable: true,
      sortField: 'year',
    },
    {
      name: 'Grade',
      selector: (row) => row.grade,
      sortable: true,
      sortField: 'grade',
    },
    {
      name: 'Harga Dasar',
      selector: (row) => row.basePrice,
      sortable: true,
      cell: (row) => moneyParser(row.basePrice),
      sortField: 'baseprice',
    },
    {
      name: 'Harga Terbentuk',
      selector: (row) => row.finalPrice,
      sortable: true,
      sortField: 'finalprice',
      cell: (row) => moneyParser(row.finalPrice),
    },
    {
      name: 'Aksi',
      cell: (row) => (
        <button
          className="btn btn-sm"
          onClick={() => onSearchDetail(row.id)}
          style={{
            border: '2px solid #007bff',
            width: 35,
            height: 35,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <FontAwesomeIcon style={{ color: '#007bff', fontSize: 15 }} icon={faEye} />
        </button>
      ),
    },
  ];



  const onSearchDetail = (id) => {
    Axios.post(API_MARKETPRICE_DB.detail, { id: id }, {
      headers: HEADER_AUTH
    })
      .then((res) => {
        const data = res.data.data;

        setDetail(data);

        $('#modal-kendaraan').modal('toggle');
      })
      .catch((err) => { });
  };

  useCheckAuth({ showModalCheckPremium: true })


  return (
    <div>
      {detail && <DetailKendaraan item={detail} />}
      <LoginModal pageChannel="Market DB" />

      <div className="container-fluid main-marketpricedb">
        <TopNav pageChannel="Market DB" />
        <div className="row" style={{ minHeight: '93vh' }}>
          <Sidebar pageChannel="Market DB" />
          <BottomNav history={history} />


          {!searching ? (
            <div className="col-xl-10 col-lg-12 pt-3 px-5 content mb-3">
              {data === null ? (
                <div className="row bg-light p-5">
                  <div className="col-xl-12">
                    <h4 className="title2">Filter Pencarian</h4>
                    {marketprice && (
                      <FilterMarketpriceDb
                        onSearch={onSearch}
                        page={page}
                        perPage={perPage}
                        loading={marketprice.loading}
                        selected={marketprice}
                      />
                    )}
                  </div>
                </div>
              ) : data ? (
                <div>
                  <div className="row bg-white p-2 mb-4">
                    <div className="col-xl-12">
                      <p className="m-0 py-4">
                        <div className="d-flex flex-row align-items-center justify-content-between">
                          <strong>Filter Pencarian</strong>
                          <button className="btn" onClick={() => setFilterOpen(!filterOpen)}>
                            {filterOpen ? (
                              <FontAwesomeIcon icon={faAngleDown} />
                            ) : (
                              <FontAwesomeIcon icon={faAngleRight} />
                            )}
                          </button>
                        </div>
                        <div className={`${filterOpen ? 'd-block' : 'd-none'}`}>
                          {marketprice && (
                            <FilterMarketpriceDb
                              onSearch={onSearch}
                              page={page}
                              perPage={perPage}
                              loading={marketprice.loading}
                              selected={marketprice}
                            />
                          )}
                        </div>
                      </p>
                    </div>
                  </div>
                  <div className="row bg-light p-2">
                    <div className="col-xl-4">
                      <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
                        Hasil Pencarian : <strong className="fw-bold">{marketprice.total_data}</strong> Data
                      </p>
                    </div>
                    <div className="col-xl-8 d-flex justify-content-end align-items-center mt-0">
                      <button
                        className="btn"
                        style={{
                          fontSize: '1rem',
                          marginRight: 10,
                          color: type === 'table' ? '#82be2a' : '#000000',
                        }}
                        onClick={() => {
                          setType('table');
                        }}
                      >
                        <FontAwesomeIcon className="mr-2" icon={faTable} />
                        Tabel
                      </button>
                      <div
                        className="ml-1"
                        style={{
                          width: 1,
                          height: 30,
                          backgroundColor: 'black',
                        }}
                      ></div>
                      <button
                        className="btn ml-4"
                        style={{
                          fontSize: '1rem',
                          marginRight: 10,
                          color: type == 'list' ? '#82be2a' : '#000000',
                        }}
                        onClick={() => {
                          setType('list');
                        }}
                      >
                        <FontAwesomeIcon className="mr-2" icon={faList} />
                        Daftar
                      </button>
                      <div className="ml-5 d-flex flex-row gap-2">
                        <input
                          type="text"
                          placeholder="Cari tahun atau harga terbentuk"
                          className="form-control"
                          style={{ width: 300 }}
                          onChange={(e) => setKeyword(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row bg-light pb-3">
                    <div className="col-xl-12">
                      {type == 'table' ? (
                        <DataTable
                          customStyles={{
                            rows: {
                              style: {
                                minHeight: '72px',
                                textAlign: 'center',
                                color: 'black',
                                fontWeight: 700,
                              },
                            },
                            headCells: {
                              style: {
                                paddingLeft: '8px', // override the cell padding for head cells
                                paddingRight: '8px',
                                fontSize: 15,
                                color: 'gray',
                              },
                            },
                            cells: {
                              style: {
                                paddingLeft: '8px', // override the cell padding for data cells
                                paddingRight: '8px',
                              },
                            },
                          }}
                          columns={columns}
                          data={data}
                          progressPending={marketprice.loading}
                          pagination
                          paginationServer
                          paginationTotalRows={marketprice.total_data}
                          onChangePage={handlePageChange}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onSort={handleSort}
                          sortServer
                        />
                      ) : (
                        <div className="container-fluid">
                          {data.map((item) => {
                            return (
                              <div className="row mb-4 d-flex align-items-center">
                                <div className="col-xl-4">
                                  <img src={item.picture[0]} style={{ width: '100%', height: '100%' }} />
                                </div>
                                <div className="col-xl-8 py-3">
                                  <div className="row">
                                    <div
                                      className="col-md-3"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>Kendaraan</h7>
                                    </div>
                                    <div
                                      className="col-md-1"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>:</h7>
                                    </div>
                                    <div
                                      className="col-md-8"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>{item.title}</h7>
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div
                                      className="col-md-3"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>Tahun</h7>
                                    </div>
                                    <div
                                      className="col-md-1"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>:</h7>
                                    </div>
                                    <div
                                      className="col-md-8"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>{item.year}</h7>
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div
                                      className="col-md-3"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>Jenis</h7>
                                    </div>
                                    <div
                                      className="col-md-1"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>:</h7>
                                    </div>
                                    <div
                                      className="col-md-8"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>{item.grade}</h7>
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div
                                      className="col-md-3"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>Harga Dasar</h7>
                                    </div>
                                    <div
                                      className="col-md-1"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>:</h7>
                                    </div>
                                    <div
                                      className="col-md-8"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>{moneyParser(item.basePrice)}</h7>
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div
                                      className="col-md-3"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>Harga Terbentuk</h7>
                                    </div>
                                    <div
                                      className="col-md-1"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>:</h7>
                                    </div>
                                    <div
                                      className="col-md-8"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <h7>{moneyParser(item.finalPrice)}</h7>
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div
                                      className="col-md-"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <Button
                                        onClick={() => onSearchDetail(item.id)}
                                      >
                                        <Typography color='purple'>Lihat Detail</Typography>
                                        <FontAwesomeIcon
                                          className="ml-3"
                                          style={{ fontSize: 15 }}
                                          color='purple'
                                          icon={faAngleRight}
                                        />
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                                <span className="hr4"></span>
                              </div>
                            );
                          })}
                          <PaginationListView
                            page={page}
                            perPage={perPage}
                            onChangePage={handlePageChange}
                            total_data={marketprice.total_data}
                            data={data}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : marketprice.error ? (
                <div className="row">
                  <div className="col-xl-12 text-center bg-light" style={{ paddingTop: 80, paddingBottom: 80 }}>
                    <p>
                      <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 40, color: '#777777' }} />
                    </p>
                    <span style={{ color: '#777777', fontSize: 25 }}>Data Tidak Ditemukan !</span>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-xl-12 text-center bg-light" style={{ paddingTop: 80, paddingBottom: 80 }}>
                    <p>
                      <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 40, color: '#777777' }} />
                    </p>
                    <span style={{ color: '#777777', fontSize: 25 }}>Data Tidak Ditemukan !</span>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="col-xl-10 col-lg-12 pt-3 px-5 content mb-3">
              <div className="row bg-light p-5 mt-3">
                <div className="col-xl-12 text-center">
                  <ClipLoader size={200} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="main-marketpricedb-mobile">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 pt-3 pb-2 d-flex px-4 align-items-center header bg-white">
              <FontAwesomeIcon
                onClick={() => {
                  history.replace({ pathname: '/', state: { pageChannel: 'Market DB' } });
                }}
                className="mb-2"
                icon={faArrowLeft}
              />
              <h4 className="ml-5" style={{ fontSize: '6vw' }}>
                Market Price DB
              </h4>
            </div>
          </div>
        </div>
        {!searching ? (
          data === null && marketprice ? (
            <FilterMarketpriceDb onSearch={onSearch} selected={marketprice} />
          ) : (
            <div>
              <div className="bg-white d-flex flex-row justify-content-between align-items-center p-3 mt-3">
                <h6>Filter Pencarian</h6>
                <button className="btn" onClick={() => setFilterOpen(!filterOpen)}>
                  {filterOpen ? <FontAwesomeIcon icon={faAngleDown} /> : <FontAwesomeIcon icon={faAngleRight} />}
                </button>
              </div>
              <div className={`${filterOpen ? 'd-block' : 'd-none'}`}>
                {marketprice && (
                  <FilterMarketpriceDb
                    onSearch={onSearch}
                    page={page}
                    perPage={perPage}
                    loading={marketprice.loading}
                    selected={marketprice}
                  />
                )}
              </div>
              <div className="mt-3 bg-white p-3 d-flex flex-column">
                <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
                  Hasil Pencarian : <strong className="fw-bold">{marketprice.total_data}</strong> Data
                </p>
                <Line height={2} width="100%" color="#E6E4E4" />

                <div className="d-flex flex-column align-items-center justify-content-center">
                  {data?.length > 0 ? (
                    data.map((item) => (
                      <div className="container-fluid my-3 p-0">
                        <div className="row mt-2">
                          <div className="col-5 flex justify-content-between">
                            <h6>Kendaraan</h6>
                          </div>
                          <div className="col-1 flex justify-content-between">
                            <h6>:</h6>
                          </div>
                          <div className="col-6 flex justify-content-between">
                            <h6>{item.title}</h6>
                          </div>
                        </div>
                        <div className="row mt-2 ">
                          <div className="col-5 flex justify-content-between">
                            <h6>Tahun</h6>
                          </div>
                          <div className="col-1 flex justify-content-between">
                            <h6>:</h6>
                          </div>
                          <div className="col-6 flex justify-content-between">
                            <h6>{item.year}</h6>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-5 flex justify-content-between">
                            <h6>Jenis</h6>
                          </div>
                          <div className="col-1 flex justify-content-between">
                            <h6>:</h6>
                          </div>
                          <div className="col-6 flex justify-content-between">
                            <h6>{item.grade}</h6>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-5 flex justify-content-left">
                            <h6>Harga Dasar</h6>
                          </div>
                          <div className="col-1 flex justify-content-between">
                            <h6>:</h6>
                          </div>
                          <div className="col-6 flex justify-content-between">
                            <h6>{moneyParser(item.basePrice)}</h6>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-5 flex justify-content-between">
                            <h6 className="text-nowrap">Harga Terbentuk</h6>
                          </div>
                          <div className="col-1 flex justify-content-between">
                            <h6>:</h6>
                          </div>
                          <div className="col-6 flex justify-content-between">
                            <h6>{moneyParser(item.finalPrice)}</h6>
                          </div>
                        </div>
                        <div className="row my-3">
                          <div
                            onClick={() => {
                              onSearchDetail(item.id);
                            }}
                            className="col-12 d-flex flex-row align-items-center"
                            style={{ color: 'purple', fontWeight: 700 }}
                          >
                            Lihat Detail
                            <FontAwesomeIcon className="ml-3" style={{ fontSize: 14 }} icon={faArrowRight} />
                          </div>
                        </div>
                        <Line height={2} width="100%" color="#E6E4E4" />
                      </div>
                    ))
                  ) : marketprice.error ? (
                    <div className="row">
                      <div className="col-xl-12 text-center bg-white" style={{ paddingTop: 80, paddingBottom: 80 }}>
                        <div className="bg-white p-4 d-flex flex-row align-items-center justify-content-center">
                          <p className="m-0">There are no records to display</p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row"></div>
                  )}
                  <PaginationListView
                    page={page}
                    perPage={perPage}
                    onChangePage={handlePageChange}
                    total_data={marketprice.total_data}
                    data={data}
                  />
                </div>
              </div>
            </div>
          )
        ) : (
          <div className="col-xl-10 col-lg-12 pt-3 px-5 content mb-3">
            <div className="row bg-light p-5 mt-3">
              <div className="col-xl-12 text-center">
                <ClipLoader size={200} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MarketPricedb;
